import { createCrudThunks } from '../../store/createCrudThunks';
import { meetingApi, type MeetingListParams } from './meetingApi';
import type { Meeting, MeetingCreatePayload, MeetingUpdatePayload } from './meetingTypes';

const thunks = createCrudThunks<Meeting, MeetingCreatePayload, MeetingUpdatePayload, MeetingListParams>(
  'meetings',
  meetingApi,
);

export const meetingThunks = thunks;
export const {
  fetchAll: fetchMeetings,
  fetchOne: fetchMeeting,
  create: createMeeting,
  update: updateMeeting,
  remove: deleteMeeting,
} = thunks;
